export const contactPhoneRegex = new RegExp(/^\+?[-\s.()]*\d{1,3}[-\s.()]*\d{1,4}[-\s.()]*\d{1,4}[-\s.()]*\d{1,9}$/);
